import { Box, Typography } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { OrderItemHistory } from '@setvi/shared/services/react-query/query/orders/types';
import moment from 'moment';
import {
  Cost,
  Price,
  Profit
} from 'pages/products/components/products-list/useProductColumns/contents';

export const orderHistoryColumns = [
  {
    id: 'orderNumber',
    label: 'Order Number',
    width: '16%',
    cellContent: ({ erpOrderNumber }: OrderItemHistory) => {
      if (!erpOrderNumber) return '-';

      return (
        <Box>
          <Typography
            style={{
              display: 'inline-block',
              textDecoration: 'underline',
              color: TextColor.Blue,
              cursor: 'pointer'
            }}>
            {erpOrderNumber}
          </Typography>
        </Box>
      );
    }
  },
  {
    id: 'orderedOn',
    label: 'Ordered On',
    width: '16%',
    cellContent: (row: OrderItemHistory) => (
      <SText title={moment.utc(row.orderEffectiveDate).format('MM/DD/YYYY')} />
    )
  },
  {
    id: 'orderedQty',
    label: 'Ordered Qty',
    width: '16%',
    cellContent: ({ quantity }: OrderItemHistory) => (
      <SText title={quantity.toString()} />
    )
  },
  {
    id: 'sell',
    label: 'Sell',
    width: '16%',
    cellContent: ({ sell }: OrderItemHistory) => <Price value={sell} />
  },
  {
    id: 'cost',
    label: 'Cost',
    width: '16%',
    cellContent: ({ cost }: OrderItemHistory) => <Cost value={cost} />
  },
  {
    id: 'profit',
    label: 'Profit Margin',
    width: '20%',
    cellContent: ({ sell, cost }: OrderItemHistory) => (
      <Profit price={sell} cost={cost} />
    )
  }
];
